import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import { Grid, CardMedia } from '@material-ui/core';
import styled from 'styled-components';
import { Modal } from '..';
// eslint-disable-next-line no-unused-vars
import { ExclamationSymbol } from '../..';
var CleanUnclosableModal = function (options) {
    var className = options.className, img = options.img, messages = options.messages;
    return (React.createElement(Modal, __assign({}, options, { open: true, handleClose: function () { }, body: React.createElement(Grid, { className: className + " unclosed-modal", container: true, direction: 'column', alignItems: 'center' },
            React.createElement(Grid, { item: true },
                React.createElement(CardMedia, { component: 'img', image: img })),
            React.createElement(Grid, { item: true },
                React.createElement(Grid, { container: true, direction: 'column', alignItems: 'center' },
                    React.createElement(Grid, { item: true },
                        React.createElement("h4", null,
                            messages.TITLE,
                            React.createElement(ExclamationSymbol, null)))))) })));
};
export var UnclosableModal = styled(function (_a) {
    var props = __rest(_a, []);
    return React.createElement(CleanUnclosableModal, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  img {\n    border-radius: 20px;\n  }\n"], ["\n  img {\n    border-radius: 20px;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=UnclosableModal.js.map